<template>
  <Heart />
  <Placeholder v-if="!imageUrl" :text="text" :uploader-id="uploaderId" />
  <img v-else :src="imageUrl" alt="Čaká sa na obrázok produktu" />
</template>
<script>
import Placeholder from "./../../partials/Placeholder";
import Heart from "./lover/Heart";

export default {
  components: {
    Heart,
    Placeholder,
  },
  props: {
    imageUrl: {
      type: String,
      default: () => "",
    },
    text: {
      type: String,
    },
    uploaderId: {
      type: String,
    },
  },
};
</script>
